import { render, staticRenderFns } from "./CourseInfoStarRating.vue?vue&type=template&id=df0f382a&scoped=true"
import script from "./CourseInfoStarRating.vue?vue&type=script&lang=js"
export * from "./CourseInfoStarRating.vue?vue&type=script&lang=js"
import style0 from "./CourseInfoStarRating.vue?vue&type=style&index=0&id=df0f382a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0f382a",
  null
  
)

export default component.exports